
/**
 * @Description TODO 文件功能说明：全局函数定义 系统交互方法
 * @author 
 * @date 
 * @Ver 
 * @extends Vue
 */
// 参数信息 API
import ApiParam from '@/request/api-param';

// 出口
export function SubFn () {
	
	// ===================================== 查询电子围栏 类型 start =====================================
	/**
	 * @Des 围栏 报警类型
	 * @Auth
	 * @Date 
	 */
	var eTypes = [
		{label: '入界区域', val: 1, paneName:'first', showIndex: 0, paramKey: 'invadeAlarmSwitch'},
		{label: '出界区域', val: 2, paneName:'second', showIndex: 1, paramKey: 'outAlarmSwitch'},
		
		{label: '带离区域', val: 3, paneName:'fifth', showIndex: 4, paramKey: 'takeAwayAlarmSwitch'},
		{label: '公共区域', val: 4, paramKey: ''},
		{label: '不可定位区域', val: 5, paramKey: ''},
		{label: '可定位区域', val: 6, paramKey: ''},
		
		{label: '聚众区域', val: 7, paneName:'third', showIndex: 2, paramKey: 'crowdAlarmSwitch'},
		{label: '周界区域', val: 8, paneName:'fourth', showIndex: 3, paramKey: 'perimeterAlarmSwitch'},
		
		{label: '点名区域', val: 9, paramKey: ''},
		{label: '考勤区域', val: 10, paramKey: ''},
	];
	
	/**
	 * @Des 查询参数配置
	 * @Auth
	 * @Date 
	 */
	this.searchETypes = function (that, callBack) {
		let self = that;
		let _eTypes = [];
		self.$request.postJsonRequest(ApiParam.searchParam,{
			projectId: self.$store.state.currentProjectId,
		}).then(result => {
			
			let rows = !self.$checkEmpty(result.rows) ? result.rows : [];
			// 遍历
			Object.assign([], eTypes).forEach((row, index) => {
				// 遍历
				Object.assign([], rows).forEach((r, i) => {
					
					if (r.paramId == row.paramKey && r.paramValue == 'true') {
						_eTypes.push(row);
						rows.splice(i, 1);
					}
					
				});
			});
			
			// 排序
			_eTypes.sort((a, b) => {
				return a.showIndex - b.showIndex;
			});
			
			typeof callBack == 'function' && callBack(Object.assign([], _eTypes));
		}).catch(error => {
			console.error('查询参数配置异常', ApiParam.searchParam, error);
			typeof callBack == 'function' && callBack(Object.assign([], _eTypes));
		});
	};
	
	// ===================================== 查询电子围栏 类型 end =====================================
	
	// ===================================== 裁剪图片 start =====================================
	/**
	 * @Des 裁剪图片
	 * @Auth
	 * @Date 
	 * @params opts {Object} 
	 * @opts: {
	 * 	src: this.imgSrc,
	 *  rect: {
	 * 		x: 0, // 截取方格左上角横坐标
	 * 		y: 0, // 截取方格左上角纵坐标
	 * 		width: 50, // 截取方格宽度
	 * 		height: 200 // 截取方格高度
	 * 	}
	 * }
	 */
	this.sliceImg = async function (opts) {
		return new Promise((resolve, reject) => {
			const { src, rect } = opts;
			if (!src || !rect) {
				reject(new Error('opts params Error!'));
			}
			const img = new Image();
			img.src = src;
			img.onload = function () {
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				const { x, y, width, height } = rect;
				canvas.width = width;
				canvas.height = height;
				ctx.drawImage(this, x, y, width, height, 0, 0, width, height);
				const url = canvas.toDataURL('image/png');
				resolve(url);
			};
			img.onerror = function (err) {
				reject(err);
			};
		});
	};
	// ===================================== 裁剪图片 end =====================================
	
};




// WEBPACK FOOTER //
// ./src/global/global-sub-function.js